// noinspection TypeScriptValidateTypes

import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import {useNavigate} from 'react-router-dom'
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SettingsIcon from '@mui/icons-material/Settings';
import {updateGameActiveTab, updatePageState} from "../../redux/slices/settings";
import {useAppDispatch, useAppSelector} from "../../redux";
import {iOS} from "../../utils";
import {disableActiveGame} from "../../redux/slices/fixtures";
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import PersonIcon from '@mui/icons-material/Person';

import './index.scss'

import {useState} from "react";
import {logout} from "../../redux/slices/account";

function swap(json: any) {
    let ret: any = {}
    for (let key in json) {
        // @ts-ignore
        ret[json[key]] = key
    }
    return ret
}

const page_routes = {
    '/account': 'Account',
    // '/daily': 'Daily tips',
    '/tips': 'Tips',
    '/statistics': 'Statistics',
    '/pre-match': 'Pre-match',
    '/my-filters': 'My Filters',
    // '/settings': 'Settings',
    '/': 'Home',
}
const pages_mobile: Array<string> = ['Home', 'Statistics', 'Settings', 'Account']

const ResponsiveAppBar = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const isIOSDevice = iOS()

    const [anchorElNav, setAnchorElNav] = React.useState<null | any>(null)
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null)
    const {activePage, gameActiveTab} = useAppSelector(state => state.settings)
    const {tips} = useAppSelector(state => state.live_tips)
    const {token} = useAppSelector(state => state.account)

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget)
    }

    const handleCloseNavMenu = () => {
        setAnchorElNav(null)
    }

    const handleCloseUserMenu = () => {
        setAnchorElUser(null)
    }

    const goToPage = (page: string) => {
        handleCloseNavMenu()

        if (page === 'Live') {
            dispatch(updateGameActiveTab(gameActiveTab))
            dispatch(disableActiveGame())
        }

        dispatch(updatePageState(page))

        if (swap(page_routes)[page]) {
            navigate(swap(page_routes)[page])
        } else {
            navigate('/')
        }
    }

    const [isDarkMode, setIsDarkMode] = useState(localStorage.getItem('theme') === 'dark');

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);

        document.body.setAttribute('data-theme', isDarkMode ? 'light' : 'dark');
        localStorage.setItem('theme', isDarkMode ? 'light' : 'dark');

        handleCloseUserMenu()
    };

    const onClickLogout = () => {
        dispatch(logout())
        handleCloseUserMenu()
        navigate('/')
    }

    const onClickSettings = () => {
        handleCloseUserMenu()
        navigate('/settings')
    }

    return (
        <AppBar className="header-wrapper" sx={{flexGrow: 1, margin: 'auto'}}>
            <div className="lg:mx-9">
                <Toolbar disableGutters>
                    <Typography variant='h6' noWrap sx={{
                        mr: 2,
                        display: {xs: 'none', md: 'flex'},
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        color: 'inherit',
                        textDecoration: 'none'
                    }}>
                        <img
                             alt='Logo'
                             src='/images/logo-small-center.png'
                             style={{height: '50px', cursor: 'pointer'}}
                             onClick={() => navigate('/')}
                        />

                    </Typography>

                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <Menu
                            id='menu-appbar'
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'}
                            }}
                        >
                            {pages_mobile.map((page) => (
                                <MenuItem key={page} onClick={() => goToPage(page)}>
                                    <Typography textAlign='center'>{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Typography
                        variant='h5'
                        noWrap
                        component='a'
                        href=''
                        sx={{
                            mr: 2,
                            display: {xs: 'flex', md: 'none'},
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none'
                        }}
                    >
                        <img src='/images/logo-small-center.png' alt='Logo' style={{height: '50px'}}/>
                    </Typography>
                    <Box className="menu" sx={{display: {xs: 'none', md: 'flex'}}}>
                        <Button key='home' onClick={() => goToPage('Home')}>
                            Home
                        </Button>

                        {/*<Button key='tips' onClick={() => goToPage('Tips')}>*/}
                        {/*    Tips*/}
                        {/*</Button>*/}

                        <Button key='statistics' onClick={() => goToPage('Statistics')}>
                            Statistics
                        </Button>
                        <Button key='pre-match' onClick={() => goToPage('Pre-match')}>
                            Pre-match
                        </Button>
                        {
                            token &&
                            <Button key='my-filters' onClick={() => goToPage('My Filters')}>
                                My Filters
                            </Button>
                        }

                        <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                            <AccountCircleIcon/>
                        </IconButton>
                    </Box>

                    <div>
                        <Box sx={{flexGrow: 0}}>
                            <Menu
                                sx={{mt: '45px'}}
                                id='menu-appbar'
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {
                                    token &&
                                    <MenuItem key='account' onClick={() => goToPage('Account')}>
                                        <Typography textAlign='center'>
                                            <PersonIcon/>Account
                                        </Typography>
                                    </MenuItem>
                                }
                                <MenuItem key='settings' onClick={onClickSettings}>
                                    <Typography textAlign='center'>
                                        <SettingsIcon/>Settings
                                    </Typography>
                                </MenuItem>

                                <MenuItem key='theme' onClick={toggleDarkMode}>
                                    <Typography style={{marginRight: '10px', cursor: 'pointer'}}>
                                        {localStorage.getItem('theme') === 'light' ? (
                                            <DarkModeIcon />
                                        ) : (
                                            <LightModeIcon/>
                                        )}Theme
                                    </Typography>
                                </MenuItem>

                                {
                                    token ?
                                    <MenuItem key='logout' className='logout-menu-item' onClick={() => onClickLogout()}>
                                        <Typography textAlign='center'>
                                            <LogoutIcon/>Log out
                                        </Typography>
                                    </MenuItem> :
                                    <MenuItem key='login' className='logout-menu-item' onClick={() => navigate('/login')}>
                                        <Typography textAlign='center'>
                                            <LoginIcon/>Log in
                                        </Typography>
                                    </MenuItem>
                                }

                            </Menu>
                        </Box>
                    </div>
                </Toolbar>
            </div>
            <div className={`bottom-menu ${isIOSDevice ? ' h-20' : ''}`}>
                <div className={"live" + (activePage === 'Live' ? ' active' : '')} onClick={() => goToPage('Live')}>
                    <TrackChangesIcon/>
                    <div className="name">Live</div>
                </div>
                <div className={"tips" + (activePage === 'Tips' ? ' active' : '')} onClick={() => goToPage('Tips')}>
                    <FactCheckIcon/>
                    <div className="name">
                        Tips
                        {
                            tips.filter(t => t.status === 'pending').length ? <div className="active-games">{tips.filter(t => t.status === 'pending').length}</div> : ''
                        }
                    </div>
                </div>
                <div className={"statistics" + (activePage === 'Statistics' ? ' active' : '')}
                     onClick={() => goToPage('Statistics')}>
                    <AnalyticsIcon/>
                    <div className="name">Statistics</div>
                </div>
                <div className={"user"}
                     onClick={handleOpenUserMenu}>
                    <AccountCircleIcon/>
                    <div className="name">User</div>
                </div>
            </div>
        </AppBar>
    )
}
export default ResponsiveAppBar
